export default {
  heading: 'Lora',
  body: 'Lora',
  monospace: 'Menlo, monospace',
  display: 'Lora',
  googleFonts: ['Lora']
  // customFamilies: ['', ''],
  // customUrls: ['', ''],
}
